import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { CompareStore, MAX_AMOUNT_ALLOWED } from '../../stores/CompareStore';
import { RadioBulletMarker } from '../radio-bullet-marker';
import styles from './CompareCheckbox.css';

const IPropTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    financing: PropTypes.shape({
      priceString: PropTypes.string,
    }).isRequired,
    coverImage: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

class CompareCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this._handleAddToCompare = this._handleAddToCompare.bind(this);
  }

  _handleAddToCompare(event) {
    event.preventDefault();
    CompareStore.toggleProduct(this.props.product);
  }

  render() {
    const alreadyBeingCompared = CompareStore.products.find(product =>
      product.id === this.props.product.id);
    const maxProductsReached = CompareStore.products.length === MAX_AMOUNT_ALLOWED;
    const disabled = !alreadyBeingCompared && maxProductsReached;
    return (
      <button
        className={[this.props.className, styles.radioBullet, disabled ? styles.disabled : ''].join(' ')}
        onClick={this._handleAddToCompare}
        disabled={disabled}
      >
        <div className={styles.checkboxContainer}>
          <RadioBulletMarker
            selected={!!alreadyBeingCompared}
          />
          <span className={disabled ? styles.compareTextDisabled : styles.compareText}>
            Agregar a comparación
          </span>
        </div>
        {
          disabled &&
          <span className={styles.message}>
            Se pueden comparar hasta {MAX_AMOUNT_ALLOWED} productos
          </span>
        }
      </button>
    );
  }
}

CompareCheckbox.propTypes = IPropTypes;
CompareCheckbox.defaultProps = defaultProps;

const WrappedCompareCheckbox = observer(CompareCheckbox);

export { WrappedCompareCheckbox as CompareCheckbox };



// WEBPACK FOOTER //
// ./src/common/compare-checkbox/CompareCheckbox.jsx